var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _ellipse, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.52 115.11l-6.18 5.77c-2.38 2.22-6.13 2.08-8.34-.31L21.75 31.98l9.47-7.7l84.48 82.58c2.28 2.31 2.19 6.03-.18 8.25z",
    fill: "#a06841"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.99 40.08l18.86 21.09c2.55-4.96 4.22-10.44 4.8-15.93l-18.1-17.71a15.997 15.997 0 0 0-3.4 4.24c-1.39 2.55-2.06 5.41-2.16 8.31z",
    fill: "#7d5133"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.09 18.14l-8.23-8.26a10.058 10.058 0 0 0-7.14-2.98c-2.68.01-5.23 1.05-7.15 2.96L6.98 39.35A10 10 0 0 0 4 46.49c0 2.7 1.05 5.23 2.96 7.15l8.24 8.26c1.92 1.92 4.47 2.98 7.19 2.98h.06c2.69-.01 5.2-1.07 7.05-2.96l29.58-29.49c1.92-1.91 2.97-4.45 2.98-7.14s-1.06-5.23-2.97-7.15z",
    fill: "#82aec0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.57 20.2c-1.28.1-2.37.92-3.38 1.7c-1.52 1.18-3.09 2.41-4.03 4.1s-1.11 3.96.11 5.45c1.85 2.25 17.64-12.06 7.3-11.25z",
    fill: "#a06841"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.05 61.17C23.63 56.76 14.4 46.06 14.17 45.8c-1.6-1.76-5.76-1.34-9-.14c-.7.26-1.17.95-1.11 1.7c.1 1.44.65 3.93 2.9 6.28l8.24 8.26c1.92 1.92 4.47 2.98 7.19 2.98h.06c2.12-.01 4.12-.67 5.78-1.87c.48-.34.57-.99.19-1.45c-.12-.14-.24-.27-.37-.39z",
    fill: "#2f7889"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 114.79l6.18 5.77c2.38 2.22 5.4 2.81 7.61.42l79.24-88.59l-9.47-7.7l-84.47 82.58c-2.28 2.32-1.47 5.3.91 7.52z",
    fill: "#a06841"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.19 40.49L78.08 59.62c5.2-13.54-.63-19.77-.63-19.77l12.19-11.91c1.36 1.21 2.53 2.65 3.4 4.24c1.39 2.55 2.06 5.41 2.15 8.31z",
    fill: "#7d5133"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.62 20.61c1.28.1 2.37.92 3.38 1.7c1.52 1.18 3.09 2.41 4.03 4.1s1.11 3.96-.11 5.45c-1.85 2.26-17.65-12.05-7.3-11.25z",
    fill: "#a06841"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.28 77.29l11.25 12.58c-1.07-4.39-.07-14.54 4.41-19.92l-4.86-4.75l-10.8 12.09z",
    fill: "#7d5133"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M123.97 61.71c-1.08-8.66-5.05-23.96-17.39-38.27C94.43 9.36 78.24 5.97 74.46 5.34c0 0-.63-.1-.89 0c-.22.09-.49.25-.49.25l-8.72 6.43s-.4 5.06.25 5.09c4.2.22 20.15 1.42 24.34 7.17c0 0-7.17 8.91-9.26 11.6h.01c-.02.02-.04.03-.05.05c-.76.76-1 1.68-.87 2.68c2.07-1.6 4.77-.23 7.26 2.26c2.53 2.53 3.92 5.26 2.17 7.35c1.08.2 2.06-.04 2.88-.85c.13-.13 8.63-9.17 8.64-9.16c7.29 3.14 9.39 5.88 13.36 10.55c1.29 1.52 8.75 15.55 10.49 14.43c.44-.29.46-.95.39-1.48z",
    fill: "#82aec0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M99.72 37.26l5.51-6.11c6.45 5.33 19.62 29.55 18.34 31.09c-1.21 1.45-12.28-18.98-23.85-24.98z",
    fill: "#2f7889"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.74 10.14c.47-.48.96-1.18.61-1.74c-.22-.36-.69-.46-1.11-.5c-1.18-.11-2.38.04-3.49.45c-2.08.76-8.04 6.79-10.57 9.41a.61.61 0 0 0 .52 1.03c2.2-.28 5.89-.88 6.93-1.92c1.51-1.5 7.11-6.73 7.11-6.73z",
    fill: "#b9e4ea"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-45.001 14.712 115.012)",
    cx: 14.71,
    cy: 115.01,
    rx: 4.04,
    ry: 9.74,
    fill: "#7d5133"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.95 24.28s-9.3 11.63-9.31 11.65c-.76.76-1 1.68-.87 2.68c1.84-1.43 4.19-.49 6.44 1.49c-1.28-1.69-.44-2.79-.44-2.79s8.22-9.85 10.94-13.12c.68-.81.56-2.02-.27-2.68c-3.3-2.63-12.11-8.63-21.79-10.27l-10.08 4.98c-.03.53.17.86.54.86c.28 0 .69.04.69.04c4.48.25 20.02 1.5 24.15 7.16z",
    fill: "#2f7889"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.21 16.69l9.08-5.25c.22-.13.36-.36.36-.62V5.97c0-.32-.35-.52-.63-.34l-8.73 5.53c-.45.28-.72.78-.72 1.31v3.86c0 .32.36.53.64.36z",
    fill: "#b9e4ea"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M46.88 9.51L11.42 44.97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.c21b22e73857f3901b2613b60642a59f.svg";
export { ForwardRef as ReactComponent };